var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnfavouriteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9189 18.32C21.6599 18.571 21.5409 18.934 21.5999 19.29L22.4889 24.21C22.5639 24.627 22.3879 25.049 22.0389 25.29C21.6969 25.54 21.2419 25.57 20.8689 25.37L16.4399 23.06C16.2859 22.978 16.1149 22.934 15.9399 22.929H15.6689C15.5749 22.943 15.4829 22.973 15.3989 23.019L10.9689 25.34C10.7499 25.45 10.5019 25.489 10.2589 25.45C9.66688 25.338 9.27188 24.774 9.36888 24.179L10.2589 19.259C10.3179 18.9 10.1989 18.535 9.93988 18.28L6.32888 14.78C6.02688 14.487 5.92188 14.047 6.05988 13.65C6.19388 13.254 6.53588 12.965 6.94888 12.9L11.9189 12.179C12.2969 12.14 12.6289 11.91 12.7989 11.57L14.9889 7.08C15.0409 6.98 15.1079 6.888 15.1889 6.81L15.2789 6.74C15.3259 6.688 15.3799 6.645 15.4399 6.61L15.5489 6.57L15.7189 6.5H16.1399C16.5159 6.539 16.8469 6.764 17.0199 7.1L19.2389 11.57C19.3989 11.897 19.7099 12.124 20.0689 12.179L25.0389 12.9C25.4589 12.96 25.8099 13.25 25.9489 13.65C26.0799 14.051 25.9669 14.491 25.6589 14.78L21.9189 18.32Z",
    fill: "#E7E7E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfavouriteIcon);
export default __webpack_public_path__ + "static/media/unfavourite-icon.d90460fab197fc7b7562596c465b2ac9.svg";
export { ForwardRef as ReactComponent };